/*

  HEADS UP! THIS IS A GENERATED FILE!

  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { faCheck, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { writeCustomer } from 'app/shared/actions/generated/supplier-customer.actions';
import {
  BooleanInput,
  EmailInput,
  GLNInput,
  LabelSelect,
  PipeString,
  RestaurantNumberInput,
  Select,
  ShowWhenContainsOtherThanH5,
  TaxNumberInput,
  TextInput,
} from 'components/inputs';
import { OrderFullfillmentCenterSelect } from 'components/Selects';
import domainModel from 'domain-model';
import Formsy from 'formsy-react';
import _ from 'lodash';
import lodashUUID from 'lodash-uuid';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Col, FormGroup, Label, Row } from 'reactstrap';
_.mixin(lodashUUID);

class WriteCustomerForm extends React.Component {
  static get propTypes() {
    return {
      entity: PropTypes.object.isRequired,
      immutableFields: PropTypes.object,
      onChange: PropTypes.func,
      resetOnSubmit: PropTypes.bool,
      onSubmit: PropTypes.func,
      translateError: PropTypes.func,
      transformParamsPreSubmit: PropTypes.func,
      className: PropTypes.string,
      mutateEntityOnChange: PropTypes.func,
      submitButtonText: PropTypes.string,
      color: PropTypes.string,
      readonly: PropTypes.bool,
      disabled: PropTypes.bool,
      modal: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      immutableFields: {},
      submitButtonText: 'Spara',
      resetOnSubmit: false,
      transformParamsPreSubmit: params => params,
      onChange: () => {},
      color: undefined,
      className: '',
      readonly: false,
      disabled: false,
      modal: false,
      mutateEntityOnChange: entity => entity,
      onSubmit: () => {},
      translateError: err => {
        if (_.get(err, 'response.status') === 409) {
          const uniqueErrors = err.response.data.data.filter(
            error => error.path !== 'owningSupplierOrganizationId',
          );

          const result = uniqueErrors
            .map(
              uniqueError =>
                `${domainModel.getTranslation(
                  'supplierCustomer',
                  uniqueError.path,
                )} finns redan och måste vara unikt`,
            )
            .join('\n');
          return result;
        }
        if (_.get(err, 'response.status') === 422) {
          const validationErrors = err.response.data.data;
          const result = validationErrors.map(validation => validation.message);
          return result.join('\n');
        }
        return _.get(err, 'response.data.message', JSON.stringify(err));
      },
    };
  }

  static defaultActionValues() {
    return {
      id: _.uuid(),
      name: '',
      orderFullfillmentCenter: undefined,
      organisationNumber: '',
      customerNumber: '',
      customerType: '',
      restaurantNumber: undefined,
      chain: undefined,
      phone: '',
      email: undefined,
      GLN: undefined,
      termsOfPayment: '',
      yourReference: '',
      requiresGroupInvoice: true,
      contractualCustomer: false,
      invoiceDeliveryType: 'EMAIL',
      emailInvoice: undefined,
      invoiceAddress: '',
      invoiceAddress2: '',
      invoiceZipCode: '',
      invoiceCity: '',
      invoiceCountry: '',
      deliveryName: '',
      deliveryAddress: '',
      deliveryAddress2: '',
      deliveryZipCode: '',
      deliveryCity: '',
      deliveryCountry: 'SE',
      exciseNumber: undefined,
      taxWarehouseNumber: undefined,
      hasAlcoholPermit: false,
      labels: [],
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return {
      submitting: false,
      errorMessage: JSON.stringify({
        message: error.message,
        stack: error.stack,
      }),
    };
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setFormToValid = this.setFormToValid.bind(this);
    this.setFormToInvalid = this.setFormToInvalid.bind(this);
    this.createMergedEntity = this.createMergedEntity.bind(this);
    this.update = this.update.bind(this);

    this.state = {
      entity: this.createMergedEntity(),
      formIsValid: true,
    };
  }

  componentDidUpdate(prevProps) {
    const { entity } = this.props;
    if (entity !== prevProps.entity) {
      // eslint-disable-next-line
      this.setState({ entity: this.createMergedEntity() });
    }
  }

  handleOnClick(event) {
    event.stopPropagation();
    if (event.detail !== 1) {
      return;
    }
    this.handleSubmit(event);
  }

  async handleSubmit(event) {
    event.stopPropagation();

    const {
      immutableFields,
      onSubmit,
      resetOnSubmit,
      transformParamsPreSubmit,
      translateError,
    } = this.props;
    const { entity } = this.state;

    await this.setState({
      submitting: true,
      errorMessage: undefined,
      submitResult: null,
    });

    let submitParams = entity;
    if (transformParamsPreSubmit && _.isFunction(transformParamsPreSubmit)) {
      submitParams = transformParamsPreSubmit(entity);
    }

    let result = null;

    try {
      const response = await writeCustomer(submitParams);
      result = response.data;
    } catch (err) {
      await this.setState({
        submitting: false,
        errorMessage: translateError(err),
        submitResult: 'error',
      });
      return;
    }

    if (resetOnSubmit) {
      this.form && this.form.reset();
      await this.update({
        ...WriteCustomerForm.defaultActionValues(),
        ...immutableFields,
      });
    }
    try {
      await onSubmit(submitParams, result);
    } catch (err) {
      /* eslint-disable-next-line no-console */
      console.error(err);
    }
    await this.setState({
      submitting: false,
      submitResult: 'success',
      errorMessage: undefined,
    });
  }

  async handleChange(modifiedKey, value, modifiedChildEntity = undefined) {
    const { entity } = this.state;
    await this.update(
      { ...entity, [modifiedKey]: value },
      modifiedKey,
      modifiedChildEntity,
    );
    await this.setState({
      submitting: false,
      submitResult: null,
      errorMessage: undefined,
    });
  }

  setFormToValid() {
    this.setState({ formIsValid: true });
  }

  setFormToInvalid() {
    this.setState({ formIsValid: false });
  }

  createMergedEntity() {
    const { entity, immutableFields } = this.props;
    return domainModel.supplierCustomer.ensureInvariants({
      ...WriteCustomerForm.defaultActionValues(),
      ...entity,
      ...immutableFields,
    });
  }

  update(entity, modifiedKey, modifiedChildEntity = undefined) {
    const { mutateEntityOnChange, onChange, immutableFields } = this.props;
    const mutatedEntity = mutateEntityOnChange(entity, modifiedChildEntity);
    const ensuredEntity = domainModel.supplierCustomer.ensureInvariants({
      ...mutatedEntity,
      ...immutableFields,
    });
    this.setState({ entity: ensuredEntity });
    onChange(entity, modifiedKey, modifiedChildEntity);
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      props: {
        immutableFields,
        submitButtonText,
        color,
        className,
        readonly,
        disabled,
        sessionUser,
        modal,
      },
      state: { entity, formIsValid, submitting, errorMessage },
    } = this;
    /* eslint-enable */

    return (
      <Formsy
        onValid={this.setFormToValid}
        onInvalid={this.setFormToInvalid}
        ref={c => {
          this.form = c;
        }}
      >
        {/* eslint-disable-next-line */}
        {/* eslint-disable-next-line */}
        <Row>
          <ShowWhenContainsOtherThanH5>
            {/* eslint-disable-next-line */}
            {typeof immutableFields.name === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Företagsnamn på faktura</Label>

                  <TextInput
                    name="name"
                    id={`nameField-${entity.id}`}
                    value={entity.name}
                    disabled={readonly}
                    onChange={this.handleChange}
                    required={true}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.orderFullfillmentCenter === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Lagerställe</Label>

                  <OrderFullfillmentCenterSelect
                    instanceId="select-orderFullfillmentCenter"
                    name="orderFullfillmentCenter"
                    isDisabled={readonly}
                    value={entity.orderFullfillmentCenter}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.organisationNumber === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Organisationsnummer</Label>

                  <TextInput
                    name="organisationNumber"
                    id={`organisationNumberField-${entity.id}`}
                    value={entity.organisationNumber}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.customerNumber === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Kundnummer</Label>

                  <TextInput
                    name="customerNumber"
                    id={`customerNumberField-${entity.id}`}
                    value={entity.customerNumber}
                    disabled={readonly}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.customerType === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Kundtyp</Label>
                  <Select
                    type="string"
                    instanceId="select-customerType"
                    name="customerType"
                    placeholder="Skriv för att söka ..."
                    isDisabled={readonly}
                    value={entity.customerType}
                    onChange={this.handleChange}
                    options={[
                      { label: 'HoReCa', value: 'horeca' },
                      { label: 'Dagligvaruhandel', value: 'dvh' },
                      { label: 'Grossist', value: 'wholesale' },
                      { label: 'Kontor', value: 'office' },
                      { label: 'Systembolaget', value: 'systembolaget' },
                      { label: 'Leverantör till Flaivy', value: 'supplier' },
                      { label: 'Export', value: 'export' },
                      { label: 'Övrigt', value: 'other' },
                    ]}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {entity.customerType === 'horeca' &&
              typeof immutableFields.restaurantNumber === 'undefined' && (
                <Col xl={12}>
                  <FormGroup>
                    {/* eslint-disable-next-line */}

                    <Label>Restaurangnummer (8 tecken)</Label>

                    <RestaurantNumberInput
                      name="restaurantNumber"
                      id={`restaurantNumberField-${entity.id}`}
                      value={entity.restaurantNumber}
                      entity={entity}
                      disabled={readonly}
                      onChange={this.handleChange}
                    />
                    <div color="muted" className="mb-1">
                      {/* eslint-disable-next-line */} &nbsp;
                    </div>
                  </FormGroup>
                </Col>
              )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.chain === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Kedja</Label>

                  <PipeString
                    name="chain"
                    value={entity.chain}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.phone === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Telefon</Label>

                  <TextInput
                    name="phone"
                    id={`phoneField-${entity.id}`}
                    value={entity.phone}
                    disabled={readonly}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.email === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Kundens e-post (används för orderbekräftelse)</Label>

                  <EmailInput
                    name="email"
                    id={`emailField-${entity.id}`}
                    value={entity.email}
                    disabled={readonly}
                    onChange={this.handleChange}
                    allowMultiple
                    maxLength="255"
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.termsOfPayment === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Betalningsvillkor</Label>
                  <Select
                    type="string"
                    instanceId="select-termsOfPayment"
                    name="termsOfPayment"
                    placeholder="Skriv för att söka ..."
                    isDisabled={readonly}
                    value={entity.termsOfPayment}
                    onChange={this.handleChange}
                    options={[
                      { label: '0 dagar', value: '0' },
                      { label: '10 dagar', value: '10' },
                      { label: '15 dagar', value: '15' },
                      { label: '20 dagar', value: '20' },
                      { label: '30 dagar', value: '30' },
                      { label: '35 dagar', value: '35' },
                      { label: '60 dagar', value: '60' },
                      { label: '70 dagar', value: '70' },
                      { label: 'Autogiro', value: 'A' },
                      { label: 'Kontant', value: 'K' },
                      { label: 'Postförskott', value: 'PF' },
                    ]}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.yourReference === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Kundreferens</Label>

                  <TextInput
                    name="yourReference"
                    id={`yourReferenceField-${entity.id}`}
                    value={entity.yourReference}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={50}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.deliveryCountry === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Land</Label>
                  <Select
                    type="string"
                    instanceId="select-deliveryCountry"
                    name="deliveryCountry"
                    placeholder="Skriv för att söka ..."
                    isDisabled={readonly}
                    value={entity.deliveryCountry}
                    onChange={this.handleChange}
                    options={[
                      { label: 'Sverige', value: 'SE' },
                      { label: 'Finland', value: 'FI' },
                      { label: 'Norge', value: 'NO' },
                      { label: 'Danmark', value: 'DK' },
                      { label: 'Island', value: 'IS' },
                    ]}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.exciseNumber === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Punktskattenummer (13 tecken)</Label>

                  <TaxNumberInput
                    name="exciseNumber"
                    id={`exciseNumberField-${entity.id}`}
                    value={entity.exciseNumber}
                    disabled={readonly}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.taxWarehouseNumber === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Skatteupplagsnummer (13 tecken)</Label>

                  <TaxNumberInput
                    name="taxWarehouseNumber"
                    id={`taxWarehouseNumberField-${entity.id}`}
                    value={entity.taxWarehouseNumber}
                    disabled={readonly}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {entity.approvedCustomer &&
              typeof immutableFields.hasAlcoholPermit === 'undefined' && (
                <Col md={modal ? 12 : 4}>
                  <FormGroup>
                    {/* eslint-disable-next-line */}

                    <Label>Har bekräftat alkoholtillstånd</Label>

                    <BooleanInput
                      name="hasAlcoholPermit"
                      id={`hasAlcoholPermitField-${entity.id}`}
                      value={!!entity.hasAlcoholPermit}
                      disabled={readonly}
                      onChange={this.handleChange}
                    />
                    <div color="muted" className="mb-1">
                      {/* eslint-disable-next-line */} &nbsp;
                    </div>
                  </FormGroup>
                </Col>
              )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.labels === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Etiketter</Label>

                  <LabelSelect
                    name="labels"
                    value={entity.labels}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}
          </ShowWhenContainsOtherThanH5>
        </Row>
        {/* eslint-disable-next-line */}
        <Row>
          <ShowWhenContainsOtherThanH5>
            <h5>Kopplingsfält</h5>

            {/* eslint-disable-next-line */}
            {typeof immutableFields.GLN === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>GLN-nummer för köparen</Label>

                  <GLNInput
                    name="GLN"
                    id={`GLNField-${entity.id}`}
                    value={entity.GLN}
                    disabled={readonly}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}
          </ShowWhenContainsOtherThanH5>
        </Row>
        {/* eslint-disable-next-line */}
        <Row>
          <ShowWhenContainsOtherThanH5>
            <h5>Fakturering</h5>

            {/* eslint-disable-next-line */}
            {typeof immutableFields.requiresGroupInvoice === 'undefined' && (
              <Col md={modal ? 12 : 4}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Samlingsfaktura</Label>

                  <BooleanInput
                    name="requiresGroupInvoice"
                    id={`requiresGroupInvoiceField-${entity.id}`}
                    value={!!entity.requiresGroupInvoice}
                    disabled={readonly}
                    onChange={this.handleChange}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */}
                    Kunden får en samlingsfaktura för alla sina inköp under en
                    period, om nej kommer order till kunden att faktureras
                    automatiskt vid leverans
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {domainModel.user.hasAtLeastSubscriptionLevel(
              sessionUser,
              'flaivyplus',
            ) &&
              typeof immutableFields.contractualCustomer === 'undefined' && (
                <Col md={modal ? 12 : 4}>
                  <FormGroup>
                    {/* eslint-disable-next-line */}

                    <Label>Avtalkund</Label>

                    <BooleanInput
                      name="contractualCustomer"
                      id={`contractualCustomerField-${entity.id}`}
                      value={!!entity.contractualCustomer}
                      disabled={readonly}
                      onChange={this.handleChange}
                    />
                    <div color="muted" className="mb-1">
                      {/* eslint-disable-next-line */}
                      Om kunden är en avtalskund kommer de bara få köpa artiklar
                      de har avtal på via prislistor
                    </div>
                  </FormGroup>
                </Col>
              )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.invoiceDeliveryType === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Fakturaleveranssätt</Label>

                  <Select
                    instanceId="select-invoiceDeliveryType"
                    name="invoiceDeliveryType"
                    placeholder="Skriv för att söka ..."
                    isDisabled={readonly}
                    value={entity.invoiceDeliveryType}
                    onChange={this.handleChange}
                    options={[
                      { value: 'PRINT', label: 'Utskrift' || 'PRINT' },
                      { value: 'EMAIL', label: 'E-post' || 'EMAIL' },
                      {
                        value: 'ELECTRONICINVOICE',
                        label: 'E-faktura' || 'ELECTRONICINVOICE',
                      },
                    ]}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {entity.invoiceDeliveryType === 'EMAIL' &&
              typeof immutableFields.emailInvoice === 'undefined' && (
                <Col xl={12}>
                  <FormGroup>
                    {/* eslint-disable-next-line */}

                    <Label>E-post för faktura</Label>

                    <EmailInput
                      name="emailInvoice"
                      id={`emailInvoiceField-${entity.id}`}
                      value={entity.emailInvoice}
                      disabled={readonly}
                      onChange={this.handleChange}
                      allowMultiple
                      maxLength="255"
                    />
                    <div color="muted" className="mb-1">
                      {/* eslint-disable-next-line */} &nbsp;
                    </div>
                  </FormGroup>
                </Col>
              )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.invoiceAddress === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Faktureringsadress</Label>

                  <TextInput
                    name="invoiceAddress"
                    id={`invoiceAddressField-${entity.id}`}
                    value={entity.invoiceAddress}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.invoiceAddress2 === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Faktureringsadress 2</Label>

                  <TextInput
                    name="invoiceAddress2"
                    id={`invoiceAddress2Field-${entity.id}`}
                    value={entity.invoiceAddress2}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.invoiceZipCode === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Postnummer på faktura</Label>

                  <TextInput
                    name="invoiceZipCode"
                    id={`invoiceZipCodeField-${entity.id}`}
                    value={entity.invoiceZipCode}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={10}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.invoiceCity === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Stad på faktura</Label>

                  <TextInput
                    name="invoiceCity"
                    id={`invoiceCityField-${entity.id}`}
                    value={entity.invoiceCity}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.invoiceCountry === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Fakturaadress land</Label>
                  <Select
                    type="string"
                    instanceId="select-invoiceCountry"
                    name="invoiceCountry"
                    placeholder="Skriv för att söka ..."
                    isDisabled={readonly}
                    value={entity.invoiceCountry}
                    onChange={this.handleChange}
                    options={[
                      { label: 'Sverige', value: 'SE' },
                      { label: 'Finland', value: 'FI' },
                      { label: 'Norge', value: 'NO' },
                      { label: 'Danmark', value: 'DK' },
                      { label: 'Island', value: 'IS' },
                    ]}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}
          </ShowWhenContainsOtherThanH5>
        </Row>
        {/* eslint-disable-next-line */}
        <Row>
          <ShowWhenContainsOtherThanH5>
            <h5>Leveransadress</h5>

            {/* eslint-disable-next-line */}
            {typeof immutableFields.deliveryName === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Företagsnamn för leverans</Label>

                  <TextInput
                    name="deliveryName"
                    id={`deliveryNameField-${entity.id}`}
                    value={entity.deliveryName}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.deliveryAddress === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Leveransadress</Label>

                  <TextInput
                    name="deliveryAddress"
                    id={`deliveryAddressField-${entity.id}`}
                    value={entity.deliveryAddress}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.deliveryAddress2 === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Leveransadress 2</Label>

                  <TextInput
                    name="deliveryAddress2"
                    id={`deliveryAddress2Field-${entity.id}`}
                    value={entity.deliveryAddress2}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.deliveryZipCode === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Postnummer för leverans</Label>

                  <TextInput
                    name="deliveryZipCode"
                    id={`deliveryZipCodeField-${entity.id}`}
                    value={entity.deliveryZipCode}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={10}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}

            {/* eslint-disable-next-line */}
            {typeof immutableFields.deliveryCity === 'undefined' && (
              <Col xl={12}>
                <FormGroup>
                  {/* eslint-disable-next-line */}

                  <Label>Stad för leverans</Label>

                  <TextInput
                    name="deliveryCity"
                    id={`deliveryCityField-${entity.id}`}
                    value={entity.deliveryCity}
                    disabled={readonly}
                    onChange={this.handleChange}
                    maxLength={255}
                  />
                  <div color="muted" className="mb-1">
                    {/* eslint-disable-next-line */} &nbsp;
                  </div>
                </FormGroup>
              </Col>
            )}
          </ShowWhenContainsOtherThanH5>
        </Row>
        {errorMessage && (
          <Alert color="danger" style={{ whiteSpace: 'pre-wrap' }}>
            {errorMessage}
          </Alert>
        )}
        {!readonly && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {/* Spinner, check, or cross icon left of button */}
            {submitting && (
              <span className="me-2">
                <FontAwesomeIcon icon={faSpinner} spin color="#888" />
              </span>
            )}
            {!submitting &&
              this.state &&
              this.state.submitResult === 'success' && (
                <span className="me-2">
                  <FontAwesomeIcon icon={faCheck} color="#28a745" />
                </span>
              )}
            {!submitting && this.state && this.state.submitResult === 'error' && (
              <span className="me-2">
                <FontAwesomeIcon icon={faTimes} color="#dc3545" />
              </span>
            )}
            <Button
              id="writeCustomerSubmitButton"
              onClick={event => {
                this.handleOnClick(event);
              }}
              className={`float-end d-print-none ${className}`}
              color={color || 'primary'}
              disabled={!formIsValid || submitting || disabled}
            >
              {submitButtonText}
            </Button>
          </div>
        )}
      </Formsy>
    );
  }
}

const mapStateToProps = (
  { authentication: { sessionUser } },
  { onSubmit, immutableFields, entity },
) => ({
  entity,
  sessionUser,
  onSubmit,
  immutableFields,
});

const writeCustomerExport = connect(mapStateToProps, null, null, {
  forwardRef: true,
})(WriteCustomerForm);

// eslint-disable-next-line import/prefer-default-export
export { writeCustomerExport as WriteCustomerForm };
